import { Component, inject } from '@angular/core';
import { DataOriginService } from '../proxy/planning/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  DataOriginCreateDto,
  DataOriginDto,
  DataOriginExcelDownloadDto,
  DataOriginUpdateDto,
} from '../proxy/planning/dtos/data-origin';
import { DATAORIGIN_CONFIG, DATAORIGIN_FIELDS } from './data-origin.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-data-origin',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, DataOriginService, ConfirmationService],
  templateUrl: './data-origin.html',
  styleUrl: './data-origin.scss',
})
export class DataOrigin extends BaseCrudComponent<
  DataOriginDto,
  DataOriginCreateDto,
  DataOriginUpdateDto,
  DataOriginExcelDownloadDto
> {
  service = inject(DataOriginService);
  config = DATAORIGIN_CONFIG;
  fields = DATAORIGIN_FIELDS;

  protected prepareUpdateDto(data: any, selected: DataOriginDto): DataOriginUpdateDto {
    return {
      name: data.name,
      code: data.code,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'DataOrigin';
  }
}
